/* FLORÉ extras: Wunschtermin im Warenkorb + WhatsApp-Button */
(function () {
  if (window.__floreExtras) return; window.__floreExtras = true;
  var d = document;
  var PHONE = '491632419464';
  var css = '' +
    '.fx-date{margin:0 0 14px;padding:14px 14px 12px;border-radius:16px;background:rgba(201,79,124,.06);border:1px solid rgba(201,79,124,.22);font-size:14px;color:inherit}' +
    '.fx-date__t{display:flex;align-items:center;gap:8px;font-weight:700;margin:0 0 10px}' +
    '.fx-date__row{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '.fx-date label{display:block;font-size:12px;opacity:.75;margin:0 0 4px}' +
    '.fx-date input,.fx-date select{width:100%;min-height:44px;padding:8px 10px;border-radius:12px;border:1px solid rgba(64,41,52,.25);background:#fff;color:#402934;font:inherit;font-size:15px}' +
    '.fx-date__hint{margin:8px 0 0;font-size:12px;opacity:.7;line-height:1.4}' +
    '.fx-date__ok{color:#2e7d4f;font-weight:600}' +
    '.fx-wa{position:fixed;right:16px;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:60;display:flex;align-items:center;gap:8px;height:52px;padding:0 18px 0 14px;border-radius:999px;background:#25d366;color:#fff!important;font:600 14px/1 system-ui,-apple-system,Segoe UI,sans-serif;text-decoration:none!important;box-shadow:0 10px 28px -10px rgba(0,0,0,.45);transition:transform .2s}' +
    '.fx-wa:hover{transform:translateY(-2px)}' +
    '.fx-wa svg{width:26px;height:26px;flex:none}' +
    '@media (max-width:749px){.fx-wa{height:54px;width:54px;padding:0;justify-content:center}.fx-wa span{display:none}}' +
    '@media print{.fx-wa{display:none}}';
  var st = d.createElement('style'); st.textContent = css; d.head.appendChild(st);

  /* ---------- WhatsApp ---------- */
  function wa() {
    if (d.querySelector('.fx-wa')) return;
    var p = location.pathname;
    var txt = 'Hallo FLORÉ, ich habe eine Frage' + (p.indexOf('/products/') === 0 ? ' zu: ' + location.href : '.');
    var a = d.createElement('a');
    a.className = 'fx-wa'; a.target = '_blank'; a.rel = 'noopener';
    a.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(txt);
    a.setAttribute('aria-label', 'Fragen per WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.4c-2.1 0-4.1-.6-5.9-1.7l-.4-.3-3.8 1.2 1.2-3.7-.3-.4a10.4 10.4 0 0 1-1.7-5.7C5.1 9.9 10 5.2 16 5.2s10.9 4.7 10.9 10.6S22 26.4 16 26.4zm6-7.9c-.3-.2-1.9-1-2.2-1.1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.2 1.4 3.4c.2.2 2.4 3.6 5.8 5 .8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z"/></svg><span>Fragen? WhatsApp</span>';
    d.body.appendChild(a);
  }

  /* ---------- Wunschtermin ---------- */
  var attrs = null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(dt) { return dt.getFullYear() + '-' + pad(dt.getMonth() + 1) + '-' + pad(dt.getDate()); }
  function de(v) { var p = v.split('-'); return p[2] + '.' + p[1] + '.' + p[0]; }
  function save(date, slot, box) {
    var a = { 'Wunschtermin': date ? de(date) : '', 'Zeitfenster': slot || '' };
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        attrs = c.attributes || {};
        var ok = box.querySelector('.fx-date__ok');
        if (ok) ok.textContent = date ? '✓ Gespeichert: ' + de(date) + (slot ? ', ' + slot : '') : '';
      }).catch(function () {});
  }
  function widget() {
    var w = d.createElement('div');
    w.className = 'fx-date';
    var today = new Date(), max = new Date(); max.setDate(max.getDate() + 60);
    w.innerHTML =
      '<p class="fx-date__t">🗓️ Wann sollen die Blumen ankommen?</p>' +
      '<div class="fx-date__row">' +
      '<div><label for="fx-d">Wunschtermin</label><input id="fx-d" type="date" min="' + iso(today) + '" max="' + iso(max) + '"></div>' +
      '<div><label for="fx-s">Zeitfenster</label><select id="fx-s"><option value="">Egal</option><option>Vormittag (9–12 Uhr)</option><option>Mittag (12–15 Uhr)</option><option>Nachmittag (15–18 Uhr)</option></select></div>' +
      '</div>' +
      '<p class="fx-date__hint">Gilt für Lieferung und Abholung. Wir bestätigen deinen Termin persönlich. <span class="fx-date__ok"></span></p>';
    var di = w.querySelector('input'), se = w.querySelector('select');
    function load() {
      if (!attrs) return;
      var t = attrs['Wunschtermin'];
      if (t && /^\d{2}\.\d{2}\.\d{4}$/.test(t)) { var p = t.split('.'); di.value = p[2] + '-' + p[1] + '-' + p[0]; }
      if (attrs['Zeitfenster']) se.value = attrs['Zeitfenster'];
      if (di.value) w.querySelector('.fx-date__ok').textContent = '✓ Gespeichert: ' + t + (se.value ? ', ' + se.value : '');
    }
    load();
    di.addEventListener('change', function () { save(di.value, se.value, w); });
    se.addEventListener('change', function () { save(di.value, se.value, w); });
    w._load = load;
    return w;
  }
  function mount() {
    var ctas = d.querySelectorAll('.cart__ctas');
    for (var i = 0; i < ctas.length; i++) {
      var c = ctas[i];
      if (c.previousElementSibling && c.previousElementSibling.classList.contains('fx-date')) continue;
      var w = widget();
      c.parentNode.insertBefore(w, c);
    }
  }
  function fetchAttrs() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      attrs = c.attributes || {};
      d.querySelectorAll('.fx-date').forEach(function (w) { w._load && w._load(); });
    }).catch(function () {});
  }

  function init() {
    wa(); mount(); fetchAttrs();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(mount, 120); }).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
